import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import { compose, setDisplayName } from 'recompose';

import { dispatchRestMaker } from 'helpers/utils';
import immutableToJS from 'helpers/immutableToJS';
import buyersActions from 'redux/buyers/actions';
import { selectState } from 'redux/selectors';
import ContactsList from './ContactsList';

export const withBuyers = (CardComp) => {
  class Buyers extends Component {
    static propTypes = {
      buyerRequesting: PropTypes.bool.isRequired,
      buyers: PropTypes.arrayOf(
        PropTypes.shape({
          id: PropTypes.number,
        }),
      ).isRequired,
      buyersRequesting: PropTypes.bool.isRequired,

      createBuyer: PropTypes.func.isRequired,
      listBuyers: PropTypes.func.isRequired,
      removeBuyer: PropTypes.func.isRequired,
      updateBuyer: PropTypes.func.isRequired,
      isRetailPage: PropTypes.bool,
    };

    static defaultProps = {
      isRetailPage: false,
    };

    render() {
      const {
        buyerRequesting,
        buyers,
        buyersRequesting,
        createBuyer,
        listBuyers,
        removeBuyer,
        updateBuyer,
        isRetailPage,
        ...restProps
      } = this.props;
      return (
        <ContactsList
          addFormTitle={!isRetailPage ? 'Add Customer' : 'Add Retail Customer'}
          addTooltip="Add New Customer"
          CardComp={CardComp}
          contactProfileKey="buyerProfile"
          contactRequesting={buyerRequesting}
          contacts={buyers}
          contactsRequesting={buyersRequesting}
          label={['A-Z', 'Group']}
          onCreateContact={createBuyer}
          onListContacts={listBuyers}
          onRemoveContact={removeBuyer}
          onUpdateContact={updateBuyer}
          searchTooltip="Search Customers"
          title="Sales Sheets"
          isRetailPage={isRetailPage}
          {...restProps}
        />
      );
    }
  }

  const mapStateToProps = state => ({
    ...selectState('buyers', 'buyer')(state, 'buyer'),
    ...selectState('buyers', 'buyers')(state, 'buyers'),
  });

  return compose(
    setDisplayName('Buyers'),
    connect(
      mapStateToProps,
      dispatchRestMaker([
        [buyersActions, 'buyer'],
      ]),
    ),
    immutableToJS,
  )(Buyers);
};

export default withBuyers;
